import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Outcomes from "@/components/site/Outcomes";
import Framework from "@/components/site/Framework";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Voices from "@/components/site/Voices";
import WhyChoose from "@/components/site/WhyChoose";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Outcomes />
        <Framework />
        <Services />
        <About />
        <WhyChoose />
        <Testimonials />
        <Voices />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
